import React, { useEffect, useState } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

const FORM_VAZIO = {
  cliente_id:"", plano_id:"", valor_mensal:"",
  data_inicio:"", data_fim:"", observacoes:""
}

const fmtMoeda = (v:any) => `R$ ${parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2})}`
const fmtData = (d:any) => d ? new Date(d).toLocaleDateString("pt-BR") : "—"

export default function Contratos() {
  const [contratos, setContratos]   = useState<any[]>([])
  const [clientes, setClientes]     = useState<any[]>([])
  const [planos, setPlanos]         = useState<any[]>([])
  const [modal, setModal]           = useState(false)
  const [editando, setEditando]     = useState<any>(null)
  const [form, setForm]             = useState<any>(FORM_VAZIO)
  const [loading, setLoading]       = useState(true)
  const [filtroCliente, setFiltroCliente] = useState("")
  const [filtroStatus, setFiltroStatus]   = useState("ativo")

  const carregar = async () => {
    try {
      const [co, cl, pl] = await Promise.all([
        axios.get(`${API}/contratos`),
        axios.get(`${API}/clientes`),
        axios.get(`${API}/planos`)
      ])
      setContratos(co.data)
      setClientes(cl.data)
      setPlanos(pl.data)
    } catch(e) { console.error(e) }
    finally { setLoading(false) }
  }

  useEffect(()=>{ carregar() },[])

  const abrirNovo = () => { setEditando(null); setForm(FORM_VAZIO); setModal(true) }
  const abrirEditar = (c:any) => {
    setEditando(c)
    setForm({
      cliente_id:c.cliente_id||"",
      plano_id:c.plano_id||"", valor_mensal:c.valor_mensal||"",
      data_inicio:c.data_inicio?c.data_inicio.split("T")[0]:"",
      data_fim:c.data_fim?c.data_fim.split("T")[0]:"",
      observacoes:c.observacoes||""
    })
    setModal(true)
  }

  const salvar = async () => {
    if (!form.cliente_id) return alert("Selecione um cliente")
    if (!form.data_inicio) return alert("Informe a data de início")
    try {
      if (editando) await axios.put(`${API}/contratos/${editando.id}`, form)
      else await axios.post(`${API}/contratos`, form)
      setModal(false); carregar()
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao salvar") }
  }

  const encerrar = async (id:string) => {
    if (!window.confirm("Encerrar contrato?")) return
    try {
      await axios.put(`${API}/contratos/${id}`, { status:"encerrado", data_fim: new Date().toISOString().split("T")[0] })
      carregar()
    } catch {}
  }

  // Calcular pro rata
  const calcProRata = (dataInicio:string, valorMensal:number) => {
    if (!dataInicio || !valorMensal) return null
    const dt = new Date(dataInicio)
    const dia = dt.getUTCDate()
    const diasMes = new Date(dt.getUTCFullYear(), dt.getUTCMonth()+1, 0).getDate()
    const diasRestantes = diasMes - dia + 1
    if (diasRestantes === diasMes) return null
    return (valorMensal / diasMes * diasRestantes)
  }

  const planoSelecionado = planos.find((p:any)=>p.id===form.plano_id)
  const valorBase = planoSelecionado ? parseFloat(planoSelecionado.valor) : 0
  const valorFinal = form.valor_mensal ? parseFloat(form.valor_mensal) : valorBase
  const proRata = calcProRata(form.data_inicio, valorFinal)

  const filtrados = contratos.filter(c => {
    if (filtroCliente && c.cliente_id !== filtroCliente) return false
    if (filtroStatus && c.status !== filtroStatus) return false
    return true
  })

const totalMensal = filtrados
    .filter(c=>c.status==="ativo")
    .reduce((s:number,c:any)=>s+parseFloat(c.valor_mensal||0),0)

  return (
    <div style={{padding:24,height:"100%",overflowY:"auto"}}>
      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:700}}>📄 Contratos</h2>
          <p style={{fontSize:13,color:"#64748b"}}>{filtrados.length} contrato(s) · Recorrência mensal: <strong style={{color:"#22c55e"}}>{fmtMoeda(totalMensal)}</strong></p>
        </div>
        <button className="btn btn-primary" onClick={abrirNovo}>+ Novo contrato</button>
      </div>

      {/* Filtros */}
      <div style={{display:"flex",gap:12,marginBottom:16,flexWrap:"wrap"}}>
        <select value={filtroCliente} onChange={e=>setFiltroCliente(e.target.value)} style={{minWidth:200}}>
          <option value="">Todos os clientes</option>
          {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
        </select>
        <select value={filtroStatus} onChange={e=>setFiltroStatus(e.target.value)}>
          <option value="">Todos os status</option>
          <option value="ativo">Ativos</option>
          <option value="encerrado">Encerrados</option>
          <option value="suspenso">Suspensos</option>
        </select>
      </div>

      {/* Cards resumo */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:12,marginBottom:20}}>
        {[
          { label:"Contratos ativos", valor:contratos.filter(c=>c.status==="ativo").length, cor:"#22c55e", icone:"📋" },
          { label:"Recorrência total", valor:fmtMoeda(contratos.filter(c=>c.status==="ativo").reduce((s:number,c:any)=>s+parseFloat(c.valor_mensal||0),0)), cor:"#0ea5e9", icone:"💰" },
          { label:"Encerrados", valor:contratos.filter(c=>c.status==="encerrado").length, cor:"#64748b", icone:"🔒" },
        ].map((s,i)=>(
          <div key={i} className="card" style={{padding:"14px 16px"}}>
            <div style={{fontSize:20,marginBottom:6}}>{s.icone}</div>
            <div style={{fontSize:18,fontWeight:700,color:s.cor}}>{s.valor}</div>
            <div style={{fontSize:11,color:"#64748b"}}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Tabela */}
      <div className="card" style={{padding:0,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{background:"#0d1b2e"}}>
              {["Cliente","Plano","Valor Mensal","Início","Fim","Status","Ações"].map(h=>(
                <th key={h} style={{padding:"10px 14px",textAlign:"left",fontSize:11,
                  color:"#64748b",fontWeight:600,textTransform:"uppercase",letterSpacing:0.5}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} style={{padding:24,textAlign:"center",color:"#64748b"}}>Carregando...</td></tr>
            ) : filtrados.length === 0 ? (
              <tr><td colSpan={8} style={{padding:24,textAlign:"center",color:"#64748b"}}>Nenhum contrato encontrado</td></tr>
            ) : filtrados.map((co:any)=>(
              <tr key={co.id} style={{borderBottom:"1px solid rgba(45,65,102,0.4)"}}>
                <td style={{padding:"10px 14px"}}>
                  <div style={{fontWeight:600,fontSize:13}}>{co.cliente_nome||"—"}</div>
                </td>
<td style={{padding:"10px 14px",fontSize:12}}>{co.plano_nome||"Personalizado"}</td>
                <td style={{padding:"10px 14px"}}>
                  <div style={{fontSize:13,fontWeight:600,color:"#22c55e"}}>{fmtMoeda(co.valor_mensal)}</div>
                </td>
                <td style={{padding:"10px 14px",fontSize:12}}>{fmtData(co.data_inicio)}</td>
                <td style={{padding:"10px 14px",fontSize:12,color:"#64748b"}}>{co.data_fim?fmtData(co.data_fim):"Em aberto"}</td>
                <td style={{padding:"10px 14px"}}>
                  <span style={{
                    fontSize:10,padding:"2px 8px",borderRadius:10,fontWeight:500,
                    background:co.status==="ativo"?"#14532d":co.status==="suspenso"?"#451a03":"#1e293b",
                    color:co.status==="ativo"?"#4ade80":co.status==="suspenso"?"#fbbf24":"#64748b"
                  }}>{co.status}</span>
                </td>
                <td style={{padding:"10px 14px"}}>
                  <div style={{display:"flex",gap:6}}>
                    <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:12}}
                      onClick={()=>abrirEditar(co)}>✏️</button>
                    {co.status==="ativo" && (
                      <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:12,color:"#f87171"}}
                        onClick={()=>encerrar(co.id)}>🔒</button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {modal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,
          display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div className="card" style={{width:"100%",maxWidth:560,maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:20}}>
              <h3>{editando?"✏️ Editar contrato":"📄 Novo contrato"}</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModal(false)}>✕</button>
            </div>

            <div className="form-grid">
              <div className="form-group full">
                <label>Cliente *</label>
                <select value={form.cliente_id} onChange={e=>setForm({...form,cliente_id:e.target.value,ativo_id:""})}>
                  <option value="">— Selecione —</option>
                  {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
                </select>
              </div>

<div className="form-group full">
                <label>Plano base</label>
                <select value={form.plano_id} onChange={e=>{
                  const p = planos.find((pl:any)=>pl.id===e.target.value)
                  setForm({...form, plano_id:e.target.value, valor_mensal:p?p.valor:form.valor_mensal})
                }}>
                  <option value="">— Selecione o plano —</option>
                  {planos.map((p:any)=>(
                    <option key={p.id} value={p.id}>{p.nome} · {fmtMoeda(p.valor)}</option>
                  ))}
                </select>
              </div>

              <div className="form-group full">
                <label>💰 Valor mensal personalizado</label>
                <div style={{position:"relative"}}>
                  <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",
                    color:"#64748b",fontSize:13}}>R$</span>
                  <input type="number" value={form.valor_mensal} step="0.01" min="0"
                    onChange={e=>setForm({...form,valor_mensal:e.target.value})}
                    placeholder={planoSelecionado?planoSelecionado.valor:"0,00"}
                    style={{paddingLeft:32}} />
                </div>
                {planoSelecionado && form.valor_mensal && parseFloat(form.valor_mensal) !== valorBase && (
                  <div style={{fontSize:11,color:"#f59e0b",marginTop:3}}>
                    ⚡ Valor personalizado (padrão do plano: {fmtMoeda(valorBase)})
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>📅 Data de início *</label>
                <input type="date" value={form.data_inicio}
                  onChange={e=>setForm({...form,data_inicio:e.target.value})} />
                {proRata !== null && (
                  <div style={{fontSize:11,color:"#f59e0b",marginTop:3}}>
                    ⚡ 1ª fatura pro rata: {fmtMoeda(proRata)}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>📅 Data de fim (opcional)</label>
                <input type="date" value={form.data_fim}
                  onChange={e=>setForm({...form,data_fim:e.target.value})} />
              </div>

              {/* Resumo financeiro */}
              {valorFinal > 0 && form.data_inicio && (
                <div className="form-group full">
                  <div style={{background:"#0c2a4a",border:"1px solid #0ea5e9",borderRadius:10,padding:14}}>
                    <div style={{fontSize:12,fontWeight:700,color:"#38bdf8",marginBottom:8}}>📊 Resumo financeiro</div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                      <div>
                        <div style={{fontSize:10,color:"#64748b"}}>Valor mensal</div>
                        <div style={{fontSize:14,fontWeight:700,color:"#22c55e"}}>{fmtMoeda(valorFinal)}</div>
                      </div>
                      {proRata !== null && (
                        <div>
                          <div style={{fontSize:10,color:"#64748b"}}>1ª fatura (pro rata)</div>
                          <div style={{fontSize:14,fontWeight:700,color:"#f59e0b"}}>{fmtMoeda(proRata)}</div>
                        </div>
                      )}
                      <div>
                        <div style={{fontSize:10,color:"#64748b"}}>Faturamento</div>
                        <div style={{fontSize:11,color:"#94a3b8"}}>Dia 01 ao 30 de cada mês</div>
                      </div>
                      <div>
                        <div style={{fontSize:10,color:"#64748b"}}>NF-e</div>
                        <div style={{fontSize:11,color:"#94a3b8"}}>Emitida dia 01 do mês seguinte</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="form-group full">
                <label>Observações</label>
                <input value={form.observacoes} onChange={e=>setForm({...form,observacoes:e.target.value})}
                  placeholder="Condições especiais, descontos negociados..." />
              </div>
            </div>

            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:20}}>
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar}>
                💾 {editando?"Salvar alterações":"Criar contrato"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
